var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('eden-page-header',{attrs:{"title":'Activities'}}),_c('all-activities')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }